var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"dashboard-buttons",attrs:{"row":"","wrap":""}},_vm._l((_vm.pages),function(page){return _c('v-flex',{key:page.id,attrs:{"xs12":"","sm6":""}},[_c('PageInNavigation',{attrs:{"page":page,"shareToken":false}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }